import { useThemeStore } from '@/store/theme';
import { themes } from '@/themes';

export function useSchoolTheme() {
  const themeKey = useThemeStore((s) => s.themeKey);
  return themes[themeKey];
}
